import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { FilterConfigService, type FilterDataResult, SearchFilterModel } from '@ui/shared/util-filter';
import type { EconomicDevelopmentFilterKey } from '../../types/economic-development-filter';

@Injectable({ providedIn: 'root' })
export class SearchFilterConfigService extends FilterConfigService<EconomicDevelopmentFilterKey, undefined> {
    public override placeholder = 'Suchbegriff eingeben';

    constructor() {
        super(
            new SearchFilterModel('search', 'Suchbegriff', []),
            undefined,
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of({ data: [] });
    }
}
